<template>
  <div>
    <div id="search">
      <el-row  v-if="version == '2'" style="height: 40px;font-size: 14px">
        <el-col>
          <el-checkbox v-model="onlyWaitSend">只看待发货(不含退款)</el-checkbox>
          <el-checkbox v-model="onlyRefund">只看退款订单</el-checkbox>
          <el-checkbox v-model="hasMemo">有备注</el-checkbox>
          <el-checkbox v-model="hasSellerRate" style="margin-right: 20px">未评价</el-checkbox>
          排序：<el-select v-model="orderField" size="mini" style="width: 160px" placeholder="请选择">
          <el-option
            v-for="item in orderOpto"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
          <el-select v-model="asc" size="mini" style="width: 80px" placeholder="请选择">
            <el-option
              v-for="item in ascOpto"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          商品名称：<el-input v-model="title" size="mini" style="width: 160px"></el-input>
        </el-col>
      </el-row>
      <el-row style="font-size: 12px">
        <el-col :span="23">
          <el-checkbox v-model="span" @change="spanChange" style="font-size: 12px; margin-right: 15px">按订单号合并</el-checkbox>
          订单号：<el-input v-model="tid" size="mini" style="width: 180px" clearable></el-input>

          <el-select v-model="timeField" size="mini" style="width: 100px" placeholder="请选择">
            <el-option
              v-for="item in timeOpto"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>

          <el-date-picker
            style="width: 320px" size="mini"
            :default-time="['00:00:00', '23:59:59']"
            v-model="payTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right">
          </el-date-picker>
          旗帜：
          <el-select v-model="flags" size="mini" multiple style="width: 200px" placeholder="请选择" @change="handleChange">
            <el-option
              v-for="item in flagOpto"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-button type="success" size="mini"  @click="getTradeData(mask)" >搜索</el-button>
        </el-col>

        <el-col :span="1">

        </el-col>
      </el-row>
      <div style="margin: 0px 0;"></div>
      <div style="width:2px;height:3px;margin-left: 30px; margin-top:0px; border-top: #dd6161 0px solid" @click=""></div>
      <el-row style="margin: 5px 0px">
        <el-col>

          <el-button type="primary" size="mini" @click="export2Excel">导出</el-button>
          <el-button type="primary" size="mini" @click="expExcel">导出(新)</el-button>
          <el-button v-if="false" type="primary" size="mini" @click="expExcel">导出</el-button>

          <span style="font-size: 12px;">导出隐私数据会加密: </span><span style="font-size: 12px;border-bottom: 1px red solid">姓名,手机,电话,收货地址,买家支付宝</span>
          <span style="font-size: 12px;margin-left: 30px">请输入手机号：</span><el-input size="mini" v-model="mobile" style="width: 120px"></el-input>
          <el-button type="primary" size="mini" @click="sendCheckCode">获取验证码</el-button>
          <span style="font-size: 12px">请输入验证码：</span><el-input size="mini" v-model="code" style="width: 100px"></el-input>
          <el-button type="primary" size="mini" @click="checkCode">验证</el-button>

        </el-col>
      </el-row>

      <div class="block" align="left" style="margin-left: 200px; color: #000">

        <span class="demonstration"></span>
        <el-pagination style="color: #000"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="pageObject.pageCurrent"
                       :page-sizes="[50, 100, 500, 1000, 2000, 5000, 20000]"
                       :page-size="pageObject.pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pageObject.rowCount">
        </el-pagination>
      </div>

    </div>


    <el-row>
      <el-col :span="8">
        <el-button type="primary" size="mini" @click="hide" style="float: left">全屏显示/恢复</el-button>
        <el-button type="primary" size="mini" @click="batDecrypt" style="float: left">批量明文</el-button>
        <el-button type="primary" size="mini" @click="showXuNiHao=true" style="float: left">虚拟号说明</el-button>
      </el-col>
    </el-row>
    <div style="height:8px; width:50px;margin-left:0px; margin-top:0px; border-bottom: #dd6161 0px solid;font-size: 12px" @click="getTrueInfo"></div>
    <el-row>
      <el-col :span="24">
        <div id="mytable" style="display:block">
          <el-table :height="tableHeight" :data="tradeData" border style="font-size: 12px"   :cell-style="{padding: '0px'}"
                    :header-cell-style="{ background:'#F2F6FC',color:'#000'}" :span-method="objectSpanMethod" :row-class-name="tableRowClassName">
            <el-table-column v-if="true" label="明文" width="50px">
              <template slot-scope="scope">
                <el-button  type="text" size="small"  style="display: inline" @click="decrypt(scope.$index, scope.row)">明文</el-button>
              </template>
            </el-table-column>
            <template v-for='(col) in myFields' style="word-wrap:break-word;" >
              <el-table-column v-if="col.field!='picPath'"
                               :show-overflow-tooltip="false"
                               :prop="col.field"
                               :label="col.title"
                               :key="col.field"
                               width="170px"
              >
              </el-table-column>
            </template>

            <el-table-column label="主图" v-if="showImg == '1'" width="160px">
              <template slot-scope="scope" >
                <img v-if="bigImg == '0'" width="60px" height="60px" :src="scope.row.picPath+'_40x40.jpg'" />
                <img v-if="bigImg == '1'" width="100px" height="100px" :src="scope.row.picPath+'_160x160.jpg'" />
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div  id="vTable" style="display:block">  <!--  style="position: absolute;top: -100000000px;display:none"  -->
          <el-table  :height="tableHeight"  border style="font-size: 12px"
                     :header-cell-style="{ background:'#F2F6FC',color:'#000'}" :span-method="objectSpanMethod" :row-class-name="tableRowClassName">
            <el-table-column v-show="false" label="明文" width="50px">
              <template slot-scope="scope">
                <el-button type="text" size="small"  style="display: inline" @click="decrypt(scope.$index, scope.row)">明文</el-button>
              </template>
            </el-table-column>
            <template v-for='(col) in hideFields' style="word-wrap:break-word;" >
              <el-table-column v-if="col.field!='picPath'"
                               :show-overflow-tooltip="false"
                               :prop="col.field"
                               :label="col.title"
                               :key="col.field"
                               width="170px"
              >
              </el-table-column>
            </template>

            <el-table-column label="主图" v-if="showImg == '1'" width="160px">
              <template slot-scope="scope" >
                <img v-if="bigImg == '0'" width="60px" height="60px" :src="scope.row.picPath+'_40x40.jpg'" />
                <img v-if="bigImg == '1'" width="100px" height="100px" :src="scope.row.picPath+'_160x160.jpg'" />
              </template>
            </el-table-column>
          </el-table>
        </div>


        <el-button v-if="false" @click="change">Copy</el-button>

      </el-col>
    </el-row>

    <div id="page" class="block" align="center">
      <span class="demonstration"></span>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageObject.pageCurrent"
        :page-sizes="[ 50, 100, 500, 1000, 2000, 5000, 20000]"
        :page-size="pageObject.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageObject.rowCount">
      </el-pagination>
    </div>

    <el-dialog
      title="虚拟号说明"
      :visible.sync="showXuNiHao"
      width="650px"
      center>

      <p>1、针对使用“号码保护”服务的买家，平台将会用虚拟号替换真实手机号</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;虚拟号形式：11位主机号+4位分机号 示例：15912341234-4567</p>
      <p>2、虚拟号可用于发货、联系买家，先拨打虚拟号11位主机号，并根据提示音输入4位分机号</p>
      <p>3、虚拟号订单快递面单打印及履约：</p>
      <p>（1）如商家使用菜鸟电子面单，虚拟号订单可以正常适配并履约</p>
      <p>（2）如商家使用非菜鸟电子面单，需确认所使用的面单是否支持虚拟号完整呈现，</p>
      <p>4、如不支持，建议商家以备注等方式将完整的虚拟号补充在电子面单上，并提供显著标识指引快递员履约</p>
      <p>  <el-link  type="primary" target="_blank" href="https://www.yuque.com/docs/share/50f0de1d-6d36-456c-9eb5-20b5918d47e3?#%20%E3%80%8A%E8%99%9A%E6%8B%9F%E5%8F%B7%E4%BB%8B%E7%BB%8D%E3%80%8B">
        点击了解更多【虚拟号】详情>>></el-link> </p>
      <p></p>


      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showXuNiHao = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"
  import cookies from "../api/cookie"
  import copy from "../api/copy"
  //:show-overflow-tooltip="true"  word-break: break-all;
  export default {
    name: "ShowPrint",
    data(){
      return{
        version:"1",
        deny:0,
        mobile:'',
        code:'',
        validCode:'',
        isChecked:false,
        display:1,
        span:true,
        showImg:'0',
        bigImg:'0',
        myFields:[],
        hideFields:[],
        tradeData:[],
        showXuNiHao:false,
        tid:'',
        payTime:[],
        title:'',
        mask:'',

        hasMemo:false,
        hasSellerRate:false,
        onlyWaitSend:false,
        onlyRefund:false,
        showRefund:false,
        timeField:'A.created',
        timeOpto:[{value:'A.created',label:'拍下时间'}, {value:'A.Pay_Time',label:'付款时间'},{value:'B.consign_time',label:'发货时间'},{value:'A.End_Time',label:'确认时间'}],
        flags:[0,1,2,3,4,5],
        sellerFlag: -1,
        flagOpto:[{value:0,label:'灰'},{value:1,label:'红'},{value:2,label:'黄'},{value:3,label:'绿'},{value:4,label:'蓝'},{value:5,label:'紫'}],
        orderField:'A.created',
        orderOpto:[{value:'A.created',label:'拍下时间'}, {value:'A.Pay_Time',label:'付款时间'},{value:'B.consign_time',label:'发货时间'},{value:'A.title',label:'商品标题（不拆单）'}],
        asc:'desc',
        ascOpto:[{value:'asc',label:'正序'},{value:'desc',label:'倒序'}],
        excelFlg:0,
        tableHeight: window.innerHeight - 80,
        pageObject: {
          pageCurrent: 1,
          rowCount: 0,
          pageSize: 100,
        },
        pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              const end = new Date();

              let year2, month2, day2
              [year2, month2, day2] = [end.getFullYear(), end.getMonth(), end.getDate()]
              let start = new Date(year2, month2, day2, 0)
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      }
    },
    methods:{
      hide:function(){
        this.display++;
        if(this.display % 2 == 0){
          window.document.getElementById("left").style.display = 'none';
          window.document.getElementById("top").style.display = 'none';
          window.document.getElementById("search").style.display = 'none';
          window.document.getElementById("page").style.display = 'none';
        }else {
          window.document.getElementById("left").style.display = 'block';
          window.document.getElementById("top").style.display = 'block';
          window.document.getElementById("search").style.display = 'block';
          window.document.getElementById("page").style.display = 'block';
        }
      },
      handleChange(){
        console.log(this.sellerFlag);
      },
      spanChange:function(){
        storage.set("span", this.span);
      },
      prepareExport:function(){
        /*let fields=" 姓名，手机，电话，收货信息，收货地址，详细地址，买家支付宝"
        for(let i=0;i<this.myFields.length;i++){
          if(fields.indexOf(this.myFields[i].title)>0){
            this.$message.error("禁止导出隐私数据, 如需导出，请去除隐私数据！");
            return;
          }
        }*/
        //导出时自动设置为最大页数，获取数据后，如果标记是导出，则执行导出操作
        this.excelFlg = 1;
        this.pageObject.pageSize = 20000;
        this.getTradeData('');
      },
      //   点击按钮  导出excel表格：
      export2Excel: function() {
        if(this.tradeData.length == 0){
          this.$message.error("没有订单数据，无需导出。");
          return;
        }
        //是否通过验证
        if(!this.isChecked){
          this.$message.error( "请先获取验证码，验证通过后再导出。" );
          return;
        }
        //导出只能导出加密的信息
        //this.getTradeData('');
        // 设置当前日期
        let nick = storage.get("nick");
        let time = new Date();
        let year = time.getFullYear();
        let month = time.getMonth() + 1;
        let day = time.getDate();
        let name = nick +"_"+ year + "" + month + "" + day;

        let tables = document.getElementById("mytable");
        let table_book = this.$XLSX.utils.table_to_book(tables);
        var table_write = this.$XLSX.write(table_book, {
          bookType: "xlsx",
          bookSST: true,
          type: "array"
        });
        try {
          this.$FileSaver.saveAs(
            new Blob([table_write], { type: "application/octet-stream" }), name+".xlsx");
        } catch (e) {
          if (typeof console !== "undefined") console.log(e, table_write);
        }
        this.isChecked = false;
        return table_write;
      },

      //导出Excel 后台操作直接下载
      expExcel:function(){
        if(this.tradeData.length == 0){
          this.$message.error("没有订单数据，无需导出。");
          return;
        }
        //是否通过验证
        if(!this.isChecked){
          this.$message.error( "请先获取验证码，验证通过后再导出。" );
          return;
        }
        let fields="";
        let fieldNames="";
        for (let i = 0; i < this.myFields.length; i++) {
          let key = this.myFields[i];
          fields = fields + key.field + ",";
          fieldNames =  fieldNames + key.title + ",";
        }
        let param = {
          isSpan: this.span,
          fields:fields,
          fieldNames:fieldNames,
          nick:  storage.get("nick"),
          tid: this.tid,
          timeField: this.timeField,
          startPayTime: this.payTime[0],
          endPayTime: this.payTime[1],
          sellerFlag: this.sellerFlag,
          flags: this.flags,
          hasMemo: this.hasMemo,
          title: this.title,
          hasSellerRate: this.hasSellerRate,
          onlyWaitSend:this.onlyWaitSend,
          onlyRefund: this.onlyRefund,
          showRefund: this.showRefund,
          orderField: this.orderField,
          asc: this.asc,
          pageCurrent: this.pageObject.pageCurrent,
          rowCount: this.pageObject.rowCount,
          pageSize: this.pageObject.pageSize,
          vaildCode: this.validCode,
          needShow: ''
        };
        console.log(this.validCode);
        $api.makeExcel("/trade/excel", param, response=>{
          console.log(response);

        })
      },

      sendCheckCode:function(){
        /*let fields=" 姓名，手机，电话，收货信息，收货地址，详细地址，买家支付宝"
        for(let i=0;i<this.myFields.length;i++){
          if(fields.indexOf(this.myFields[i].title)>0){
            this.$message.error("禁止导出隐私数据, 如需导出，请去除隐私数据！");
            return;
          }
        }*/
        if(this.tradeData.length == 0){
          this.$message.error("没有订单数据，无需导出。");
          return;
        }
        this.$confirm('导出的隐私数据，会全部加密，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'success'
        }).then(() => {
          if(this.mobile.length == 0){
            this.$message.error("请输入手机号");
            return;
          }else if(this.mobile.length != 11){
            this.$message.error("请输入11位手机号");
            return;
          }else{
            if(!(/^1[3456789]\d{9}$/.test(this.mobile)) ){
              this.$message.error("手机号不正确，请检查");
              return;
            }
          }
          storage.set("mobile", this.mobile);
          let param = {
            nick:storage.get("nick"),
            mobile:this.mobile,
          }
          $api.post("/sms/sendCheckCode", param, response=>{
            let dataResult = response.data;
            if(dataResult.message=="ok"){
              this.$message.success(dataResult.data);
            }else{
              this.$message.error(dataResult.message);
            }
          })

        })


      },
      checkCode:function(){
        if(this.code.length == 0){
          this.$message.error("请输入验证码");
          return;
        }else  if(!(/^\d{6}$/.test(this.code)) ){
          this.$message.error("验证码为6位数字，请检查");
          return;
        }
        let param = {
          nick:storage.get("nick"),
          code:this.code,
        }
        $api.post("/sms/checkCode", param, response=>{
          let dataResult = response.data;
          if(dataResult.message=="ok"){
            this.$message.success(dataResult.data);
            if(dataResult.state == 1){
              //导出只能导出加密的信息
              this.pageObject.pageSize = 20000;
              this.getTradeData('');
              this.isChecked = true;
              this.validCode = this.code;
            }
          }else{
            this.$message.error(dataResult.message);
          }
        })
      },

      //改变pageSize
      handleSizeChange: function (val) {
        this.pageObject.pageSize = val;
        this.getTradeData('');
      },
      //当前页面改变
      handleCurrentChange: function (val) {
        this.pageObject.pageCurrent = val;
        this.getTradeData('');
      },
      copyText:function(){
        /*this.$copyText("<img src='https://img.alicdn.com/bao/uploaded/i4/360449998/O1CN01vqKf0T2Nj8Qheatfk_!!360449998.jpg_40x40.jpg'/>").then(function (e) {
          alert('Copied')
          console.log(e)
        }, function (e) {
          alert('Can not copy')
          console.log(e)
        })*/
        copy.selectText("mytable")
      },
      getVersion:function(){
        let param={
          nick:storage.get("nick")
        }
        $api.post("/getVersion", param,response=>{
          let dataResult = response.data;
          if(dataResult.state=="1" && dataResult.message == "ok"){
            this.version = dataResult.data;
          }else{
            console.log(dataResult.message);

          }
        })
      },

      //获取订单列表数据 晓玲仔带商品标题排序
      getTradeData: function (needShow) {
        document.getElementById("mytable").style.display = 'block';
        document.getElementById("vTable").style.display = 'none'

        if(this.payTime == null){
          this.payTime=[];
        }
        if(this.flags.length == 0){
          this.$message.error('旗帜不能为空，请选择旗帜颜色');
          return;
        }
        //同时选待发货 或 只退款 则忽略只退款
        if(this.onlyWaitSend && this.onlyRefund)
          this.onlyRefund = false;
        //旗帜数组转字串
        let param = {
          nick:  storage.get("nick"),
          tid: this.tid,
          timeField: this.timeField,
          startPayTime: this.payTime[0],
          endPayTime: this.payTime[1],
          sellerFlag: this.sellerFlag,
          flags: this.flags,
          hasMemo: this.hasMemo,
          title: this.title,
          hasSellerRate: this.hasSellerRate,
          onlyWaitSend:this.onlyWaitSend,
          onlyRefund: this.onlyRefund,
          showRefund: this.showRefund,
          orderField: this.orderField,
          asc: this.asc,
          pageCurrent: this.pageObject.pageCurrent,
          rowCount: this.pageObject.rowCount,
          pageSize: this.pageObject.pageSize,
          needShow: needShow
        };
        console.log("getStart");
        $api.post("/trade/get", param, response => {
          let dataResult = response.data;
          if (dataResult.state == 1 && dataResult.message == "ok") {
            let tradeData = dataResult.data.trade;
            let pageObject = dataResult.data.pageObject;
            this.tradeData = tradeData;
            this.pageObject.rowCount = pageObject.rowCount;
            this.pageObject.pageSize = pageObject.pageSize;
            //检测是否需要导出
            // if(this.excelFlg == 2){
            //   let _this=this;
            //   document.getElementById("mytable").style.display = 'none';
            //   document.getElementById("vTable").style.display = 'block';
            //   this.excelFlg = 0;
            // }else{
            //   document.getElementById("mytable").style.display = 'block';
            //   document.getElementById("vTable").style.display = 'none';
            // }
          }
          else {
            this.deny = 1;
            this.$message.error(dataResult);
          }
        })
      },
      decrypt:function(index, row){
        return;

        this.$message.warning("每天限制解密20个订单，请谨慎操作，解密更多，请联系客服！");
        if(row.ordStts.indexOf("等待卖家发货")<0 ){
          this.$message.error("只能解密待发货订单，请检查订单状态");
          return;
        }
        console.log(cookies.getCookie("_ati"));
        let param={
          nick: storage.get("nick"),
          buyerNick: row.buyerNick,
          receiverName: row.receiverName,
          receiverMobile:row.receiverMobile,
          receiverPhone: row.receiverPhone,
          tid: row.tid,
          oaid: row.oaid,
          ati: cookies.getCookie("_ati")
        }
        $api.post("/decrypt", param, response => {
          let dataResult = response.data;
          if (dataResult.state == 1 && dataResult.message == "ok") {
            if((dataResult.data.message != null) && (dataResult.data.message != "")){
              this.$message.error(dataResult.data.message);
            }
            this.tradeData[index].maskNick = dataResult.data.buyerNick;
            this.tradeData[index].maskName = dataResult.data.receiverName;
            this.tradeData[index].maskMobile = dataResult.data.receiverMobile;
            this.tradeData[index].maskPhone = dataResult.data.receiverPhone;
            if(row.oaid != null)
              this.tradeData[index].receiverAddress = dataResult.data.receiverAddress;
            else
              this.tradeData[index].receiverAddress = row.trueAddress;

            let addr = this.tradeData[index].receiverState + '  ' + this.tradeData[index].receiverCity + '  '
              + this.tradeData[index].receiverDistrict + '  ' +  this.tradeData[index].receiverAddress;
            this.tradeData[index].addr1 = addr;
            this.tradeData[index].maskInfo = dataResult.data.receiverName + ',' + dataResult.data.receiverMobile + ','
              + dataResult.data.receiverPhone + ',' + addr + ',' + this.tradeData[index].receiverZip;

            this.tradeData[index].trueNick = this.tradeData[index].maskNick;
            this.tradeData[index].trueName = this.tradeData[index].maskName;
            this.tradeData[index].trueMobile =this.tradeData[index].maskMobile;
            this.tradeData[index].truePhone =this.tradeData[index].maskPhone;
            this.tradeData[index].trueAddress =this.tradeData[index].receiverAddress;
            this.tradeData[index].trueInfo =this.tradeData[index].maskInfo;
            this.tradeData[index].trueAddr1 = this.tradeData[index].addr1;
          }else{
            this.$message.error(dataResult.message);
          }
        })
      },

      batDecrypt: function(){
        if(this.tradeData.length > 0) {
          this.$confirm('请先导入数据再操作；如果已导入数据，请继续', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'success'
          }).then(() => {
            // if (this.tradeData[0].oaid != null) {
            //   //this.pageObject.pageSize = 100;
            //   this.excelFlg = 2;
            //   this.getTradeData('decrypt');
            // }
            //虚拟订单oaid为空
            this.excelFlg = 2;
            this.getTradeData('decrypt');

            //document.getElementById("mytable").style.display = 'none';
            //document.getElementById("vTable").style.display = 'block'
            this.excelFlg = 0;
          })
        }
      },

      getTrueInfo:function(){
        // document.getElementById("mytable").style.display = 'none';
        // document.getElementById("vTable").style.display = 'block';
        // copy.selectText("vTable");
        copy.selectText("mytable");
      },

      //复制 隐藏的显示
      change:function (gv) {
        console.log("rows:"+this.tradeData.length);
        document.getElementById("vTable").style.display = 'block';
        copy.selectText("vTable");
        setTimeout(function () {
          document.getElementById("vTable").style.display = 'none';
        }, 10000 * 100 );

        console.log("rows end.");
        this.$message.error("");
      },

      tableRowClassName({row, rowIndex}) {
        let rowcnt = row.rowCnt;
        if(rowcnt>1) {
          return 'same-tid';
        }
        return '';
      },
      //全并行
      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        let lpage = this.pageObject.pageCurrent;
        let lpagesize = this.pageObject.pageSize;

        if (this.span) { //this.title.length == 0
          let isSpan = 0;
          if(columnIndex>0)
            isSpan = this.myFields[columnIndex-1].span;
          else
            isSpan = 1;
          if ((isSpan == 1) ) {
            let rowcnt = row.rowCnt;
            let rownum = row.rowNum;

            let rspan=1;
            let cspan=1;
            //只要是第0行，不管序号是否为1
            if ((rowIndex == 0) || (rownum == 1)) {
              if (rowcnt - rownum + 1 > lpagesize - rowIndex) {
                rspan = lpagesize - rowIndex;
              } else {
                rspan = rowcnt - rownum + 1
              }
              cspan = 1;
            } else {
              rspan = 0;
              cspan = 0;
            }
            return {
              rowspan: rspan,
              colspan: cspan
            }
          }
        }
      },
    },
    mounted() {

      let field = storage.get("field");
      if(field == null){
        this.$message.error("您没有设置显示顺序，请返回保存显示顺序");
      }else{
        this.myFields = field;
        for(let i=0;i<this.myFields.length;i++){
          let item = this.myFields[i];
          let hide = {};
          let str = item.field;
          if(item.field == "maskNick")
            str="trueNick"
          else if(item.field == "maskName")
            str="trueName"
          else if(item.field == "maskMobile")
            str="trueMobile"
          else if(item.field == "maskPhone")
            str="truePhone"
          else if(item.field == "maskInfo")
            str="trueInfo";
          else if(item.field == "receiverAddress")
            str="trueAddress";
          else if(item.field == "addr1")
            str="trueAddr1";

          hide.title = item.title;
          hide.field = str;
          hide.span = item.span;
          this.hideFields.push(hide);
        }
      }
      let showImg = storage.get("showImg");
      if(showImg != null) {
        this.showImg = showImg;
      }
      let nicks=",trout鳟鱼,动感哥弟企业店,掏吧no1,森格家居品牌直销店,yang15968894410,艺品汇饰家2016,饭粒旗舰店,ms_tiamo,hosekyao,众艺家居旗舰店,xueping731731,tb836132503,美艺梦旗舰店,黑泽明君,wgaofa";
      let nick= storage.get("nick");
      if(nicks.indexOf(nick)>=0){
        this.bigImg = "1";
      }
      let mobile = storage.get("mobile");
      if(mobile != null){
        this.mobile = mobile;
      }
      this.getVersion();
      this.getTradeData("");
      let span =  storage.get("span");
      if(span == null)
        this.span = false;
      else
        this.span = span;
    }
  }
</script>

<style >



  /*.el-table .cell {
    white-space: nowrap;
    width: fit-content;
  }*/
</style>




// WEBPACK FOOTER //
// src/print/ShowPrint.vue